export default "__VITE_ASSET__IPV_eMja__"